export const FETCH_OFFERS = "FETCH_OFFERS";
export const SET_SELECTED_OFFER = "SET_SELECTED_OFFER";
export const SET_OTP_VERIFIED = "SET_OTP_VERIFIED";
export const SET_APP_PHASE = "SET_APP_PHASE";
export const SET_LOADING = "SET_LOADING";
export const SET_ERROR = "SET_ERROR";
export const RESET_APPLICATION = "RESET_APPLICATION";
export const SET_CANDIDATE_EMAIL = "SET_CANDIDATE_EMAIL";
